import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "fullDayFields",
    "rangeFields",
    "rangesContainer",
    "rangeTemplate",
    "addRangeBtn",
    "reportDate",
    "startTime",
    "endTime",
    "discountLunch",
    "fullDayProject",
    "fullDayActivity"
  ]

  connect() {
    this.applyScheduleType()
    this.initAllSelect2()
  }

  disconnect() {
    if (typeof jQuery === "undefined") return
    if (this.hasFullDayProjectTarget) jQuery(this.fullDayProjectTarget).off("change")
    if (this.hasRangesContainerTarget) jQuery(this.rangesContainerTarget).off("change", "[data-range-project]")
  }

  initAllSelect2() {
    if (typeof initializeSelect2 !== "function") return
    initializeSelect2(".select2-project")
    initializeSelect2(".select2-range-project")
    this.bindSelect2Events()
  }

  bindSelect2Events() {
    if (typeof jQuery === "undefined") return
    const self = this

    if (this.hasFullDayProjectTarget) {
      jQuery(this.fullDayProjectTarget).on("change", function () {
        if (this.value && self.hasFullDayActivityTarget) {
          self.fullDayActivityTarget.value = ""
        }
      })
    }

    if (this.hasRangesContainerTarget) {
      jQuery(this.rangesContainerTarget).on("change", "[data-range-project]", function () {
        const block = this.closest("[data-range-block]")
        if (!block) return
        const activitySelect = block.querySelector("[data-range-activity]")
        if (this.value && activitySelect) {
          activitySelect.value = ""
        }
      })
    }
  }

  toggleScheduleType() {
    this.applyScheduleType()
  }

  applyScheduleType() {
    const radio = this.element.querySelector('input[name="schedule_type"][value="full_day"]')
    if (!radio) return
    const isFullDay = radio.checked

    if (isFullDay) {
      if (this.hasFullDayFieldsTarget) this.fullDayFieldsTarget.style.display = ""
      if (this.hasRangeFieldsTarget) this.rangeFieldsTarget.style.display = "none"
      if (this.hasAddRangeBtnTarget) this.addRangeBtnTarget.style.display = "none"
      this.setFullDayTimes()
      if (this.hasFullDayFieldsTarget) this.toggleRequiredFields(this.fullDayFieldsTarget, true)
      if (this.hasRangeFieldsTarget) {
        this.toggleRequiredFields(this.rangeFieldsTarget, false)
        this.clearRangeSelections()
      }
    } else {
      if (this.hasFullDayFieldsTarget) {
        this.fullDayFieldsTarget.style.display = "none"
        this.toggleRequiredFields(this.fullDayFieldsTarget, false)
        this.clearFullDaySelections()
      }
      if (this.hasRangeFieldsTarget) {
        this.rangeFieldsTarget.style.display = ""
        this.toggleRequiredFields(this.rangeFieldsTarget, true)
      }
      if (this.hasAddRangeBtnTarget) this.addRangeBtnTarget.style.display = ""
    }
  }

  toggleRequiredFields(container, enabled) {
    container.querySelectorAll("select[name], input[name], textarea[name]").forEach(el => {
      if (enabled) {
        el.removeAttribute("disabled")
        if (el.hasAttribute("data-required")) el.setAttribute("required", "required")
      } else {
        el.setAttribute("disabled", "disabled")
        el.removeAttribute("required")
      }
    })
  }

  setFullDayTimes() {
    if (!this.hasStartTimeTarget) return
    this.startTimeTarget.value = "08:30"
    this.endTimeTarget.value = this.isFriday() ? "17:30" : "18:00"
    this.discountLunchTarget.value = "1"
  }

  dateChanged() {
    if (this.element.querySelector('input[name="schedule_type"][value="full_day"]').checked) {
      this.setFullDayTimes()
    }
  }

  isFriday() {
    const val = this.reportDateTarget.value
    if (!val) return false
    const parts = val.split("-")
    const date = new Date(parts[0], parts[1] - 1, parts[2])
    return date.getDay() === 5
  }

  addRange() {
    const template = this.rangeTemplateTarget
    const clone = template.content.cloneNode(true)
    const newIndex = Date.now()

    clone.querySelectorAll("[name]").forEach(el => {
      el.name = el.name.replace("__INDEX__", newIndex)
    })

    const uniqueClass = `select2-range-new-${newIndex}`
    const selectEl = clone.querySelector(".select2-range-project")
    if (selectEl) selectEl.classList.add(uniqueClass)

    this.rangesContainerTarget.appendChild(clone)
    this.updateRemoveButtons()

    if (typeof initializeSelect2 === "function") {
      initializeSelect2(`.${uniqueClass}`)
    }
  }

  removeRange(event) {
    const rangeBlock = event.target.closest("[data-range-block]")
    if (!rangeBlock) return

    const blocks = this.rangesContainerTarget.querySelectorAll("[data-range-block]")
    if (blocks.length <= 1) return

    rangeBlock.remove()
    this.updateRemoveButtons()
  }

  toggleLunch(event) {
    if (!event.target.checked) return
    this.rangesContainerTarget.querySelectorAll('input[data-lunch-checkbox]').forEach(cb => {
      if (cb !== event.target) cb.checked = false
    })
  }

  updateRemoveButtons() {
    const blocks = this.rangesContainerTarget.querySelectorAll("[data-range-block]")
    const removeButtons = this.rangesContainerTarget.querySelectorAll("[data-remove-btn]")

    removeButtons.forEach(btn => {
      btn.style.display = blocks.length <= 1 ? "none" : ""
    })
  }

  clearSelect2(el) {
    if (typeof jQuery !== "undefined") jQuery(el).val("").trigger("change")
  }

  clearFullDaySelections() {
    if (this.hasFullDayProjectTarget) {
      this.fullDayProjectTarget.value = ""
      this.clearSelect2(this.fullDayProjectTarget)
    }
    if (this.hasFullDayActivityTarget) {
      this.fullDayActivityTarget.value = ""
    }
  }

  clearRangeSelections() {
    if (!this.hasRangesContainerTarget) return
    this.rangesContainerTarget.querySelectorAll("[data-range-block]").forEach(block => {
      const projectSelect = block.querySelector("[data-range-project]")
      const activitySelect = block.querySelector("[data-range-activity]")
      if (projectSelect) {
        projectSelect.value = ""
        this.clearSelect2(projectSelect)
      }
      if (activitySelect) activitySelect.value = ""
    })
  }

  activityChanged() {
    if (!this.hasFullDayActivityTarget || !this.hasFullDayProjectTarget) return
    if (this.fullDayActivityTarget.value) {
      this.fullDayProjectTarget.value = ""
      this.clearSelect2(this.fullDayProjectTarget)
    }
  }

  rangeActivityChanged(event) {
    const block = event.target.closest("[data-range-block]")
    if (!block) return
    const projectSelect = block.querySelector("[data-range-project]")
    if (event.target.value && projectSelect) {
      projectSelect.value = ""
      this.clearSelect2(projectSelect)
    }
  }
}
